import React from "react";
import { Button } from "codekit";

import { tono } from "../../Tablerox/tonos";
import "../../Tablerox/riodo.css";
import "./cargaeje.css";

const ETAPAS = { PLANEACION: "Planeación", ELABORACION: "Elaboración", NACIONALIZACION: "Nacionalización", FINALIZACION: "Finalización" };
const puntos = (n) => Number(n ?? 0).toLocaleString("es-CO", { maximumFractionDigits: 2 });
const titulo = (texto) => String(texto ?? "").toLowerCase().replace(/(^|\s)\p{L}/gu, (l) => l.toUpperCase());

/**
 * De dónde sale la carga de un Ejecutivo de Cuenta (Diego 2026-10-01): cada operación viva con el peso de su cliente,
 * el factor de su etapa (Planeación completo; de Elaboración en adelante, seguimiento) y los puntos que suma. La
 * fila abre la operación.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-10-01
 * @param {object}   carga    {CARGA, TOPE, COPADO, SEGUIMIENTO, DETALLE: [{DOCNROXX, CLINOMXX, DOCETAPA, PESO, FACTOR, PUNTOS}]}
 * @param {string}   nombre   De quién es la carga (vacío = la propia)
 * @param {function} onAbrir  (DOCNROXX) abre la operación
 * @param {function} onCerrar Cierra el detalle
 */
const Cargaeje = ({ carga, nombre = "", onAbrir, onCerrar }) => {
  const detalle = carga?.DETALLE ?? [];
  const fuertes = detalle.filter((o) => Number(o.FACTOR) === 1);
  const suma = (lista) => lista.reduce((t, o) => t + Number(o.PUNTOS), 0);
  return (
    <div className="cargaeje">
      <div className="rio-band">
        <span className="rio-band-title">{nombre ? `Carga de ${titulo(nombre)}` : "Mi carga"}</span>
        <span className="rio-band-sub">
          {puntos(carga?.CARGA)} de {puntos(carga?.TOPE)} puntos{carga?.COPADO ? " · copado: las operaciones nuevas van a otro Ejecutivo del grupo" : ""}
        </span>
      </div>
      <div className="rio-card cargaeje-regla">
        <span className="rio-card-title">Cómo se calcula</span>
        <span className="rio-hint">
          Suman las operaciones vivas. Cada una vale el peso de su cliente: completo mientras está en Planeación y multiplicado por {puntos(carga?.SEGUIMIENTO)} de Elaboración en adelante, que es seguimiento. Los DO de registro no cuentan.
        </span>
        <div className="rio-chips">
          <span className="rio-chip" style={tono("NAVY").chip}>En Planeación: {fuertes.length} op. · {puntos(suma(fuertes))} puntos</span>
          <span className="rio-chip" style={tono("AZUL").chip}>En seguimiento: {detalle.length - fuertes.length} op. · {puntos(suma(detalle) - suma(fuertes))} puntos</span>
        </div>
      </div>
      <div className="rio-card cargaeje-tabla">
        {detalle.length === 0 && <span className="rio-hint">Sin operaciones vivas.</span>}
        {detalle.length > 0 && (
          <table>
            <thead>
              <tr><th>Operación</th><th>Cliente</th><th>Etapa</th><th className="num">Peso del cliente</th><th className="num">Factor de la etapa</th><th className="num">Puntos</th></tr>
            </thead>
            <tbody>
              {detalle.map((o) => (
                <tr key={o.DOCNROXX} className="cargaeje-fila" onClick={() => onAbrir?.(o.DOCNROXX)} title="Abrir la operación">
                  <td><strong>{o.DOCNROXX}</strong></td>
                  <td>{o.CLINOMXX}</td>
                  <td>{ETAPAS[o.DOCETAPA] ?? titulo(o.DOCETAPA)}</td>
                  <td className="num">{puntos(o.PESO)}</td>
                  <td className="num">{puntos(o.FACTOR)}</td>
                  <td className="num"><strong>{puntos(o.PUNTOS)}</strong></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr><td colSpan={5}>Total</td><td className="num"><strong>{puntos(carga?.CARGA)}</strong></td></tr>
            </tfoot>
          </table>
        )}
      </div>
      <div className="cargaeje-pie">
        <Button type="button" variant="secondary" size="m" onClick={onCerrar}>Cerrar</Button>
      </div>
    </div>
  );
};

export default Cargaeje;
